module.exports = __webpack_public_path__ + "static/face-3-9345e8351a1a78e68880d6e39df24e0e.png";